var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1L1 15M4.71429 3C4.71429 4.10457 3.88281 5 2.85714 5C1.83147 5 1 4.10457 1 3C1 1.89543 1.83147 1 2.85714 1C3.88281 1 4.71429 1.89543 4.71429 3ZM14 13C14 14.1046 13.1685 15 12.1429 15C11.1172 15 10.2857 14.1046 10.2857 13C10.2857 11.8954 11.1172 11 12.1429 11C13.1685 11 14 11.8954 14 13Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProp);
export default __webpack_public_path__ + "static/media/prop.47342d30a9d4a409d801366b2c38a716.svg";
export { ForwardRef as ReactComponent };